import React from 'react';

import { capitalize } from 'lodash';

import Spinner from 'components/loading_spinner';

interface Props {
  status: string;
}

export default function DromoImportStatus({ status }: Props) {
  let className;
  let content = <span>{capitalize(status)}</span>;

  if (status === 'failed') {
    className = 'text-danger';
  } else if (status === 'pending') {
    className = 'text-muted';
  } else if (status === 'processing') {
    content = <>
      {content}
      <Spinner className="ml-2" inline size="xs"/>
    </>;
  }

  return <span className={className}>{content}</span>;
}
